import { SeedToken } from "antd/es/theme/internal";


export const themeSettings: Partial<SeedToken> = {
    colorPrimary: '#1fa6aa' //mau chu dao
}